import { renderCellGrayZeros } from 'app/common/templates-next/table-template'

import { Entity } from './types'
import styles from './render-table-cell.module.scss'

export type TotalTitleCell = {
  columnKey: Entity.Title
  value: string | null
  type: 'isTotalTitle'
}

const isTotalTitleCell = (cellData: CommonCell): cellData is TotalTitleCell => {
  return cellData?.columnKey === Entity.Title && cellData.type === 'isTotalTitle'
}

type CommonCell = {
  columnKey: string
  value: string | null
  type?: 'isTotalTitle'
}

export const renderFooterCell = (cellData?: CommonCell) => {
  if (cellData && isTotalTitleCell(cellData)) {
    return <span className={styles.totalTitle}>{cellData.value}</span>
  }
  return renderCellGrayZeros(cellData)
}
